import { globalBreakDownStatsElementOptions } from '../../../../global-breakdown/constants/globalBreakDownStatsElementOptions';

export const iposByRegionStatsElementOptions = globalBreakDownStatsElementOptions;
